import { FitToolAndSizeChartUI } from "./FitToolAndSizeChartUI";
import { StandardProps } from "../componentMap";

export function FitToolAndSizeChart({
  experiencesRawObject,
  product,
  runtimeConfig,
}: Pick<StandardProps, "product" | "runtimeConfig" | "experiencesRawObject">) {
  return (
    <FitToolAndSizeChartUI
      experiencesRawObject={experiencesRawObject}
      product={product}
      runtimeConfig={runtimeConfig}
    />
  );
}
